import styled from "styled-components";

import { Switcher } from "@similarweb/ui-components";

import { CenteredFlexRow, FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const KeywordsGapWrapper = styled(FlexColumn)`
    width: 100%;
`;

export const KeywordsGapContentWrapper = styled(FlexRow)`
    width: 100%;
`;

export const KeywordsGapFiltersWrapper = styled(CenteredFlexRow)`
    justify-content: space-between;
    width: 100%;
`;

export const StyledSwitcher = styled(Switcher)`
    margin: 0;
`;
